import { Trans } from "@lingui/react/macro";
import { DateTime } from "luxon";
import React from "react";
import { z } from "zod";

import { CropIcon } from "@/common/components/crop-icon/crop-icon";
import { PredictionRatesToCommodity } from "@/generated/api/prices";

type CropId = PredictionRatesToCommodity;

type CropConfig = {
  id: CropId;
  label: React.ReactNode;
};

const crops: CropConfig[] = [
  {
    id: "WINTER_WHEAT",
    label: (
      <>
        {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
        <CropIcon className="w-6 h-6" cropName="Pšenice" />
        <Trans>Pšenice ozimá</Trans>
      </>
    ),
  },
  {
    id: "SPRING_BARLEY",
    label: (
      <>
        {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
        <CropIcon className="w-6 h-6" cropName="Ječmen" />
        <Trans>Ječmen jarní</Trans>
      </>
    ),
  },
  {
    id: "WINTER_RAPESEED",
    label: (
      <>
        <CropIcon className="w-6 h-6" cropName="Řepka" />
        <Trans>Řepka ozimá</Trans>
      </>
    ),
  },
  {
    id: "CORN",
    label: (
      <>
        {/* eslint-disable-next-line lingui/no-unlocalized-strings */}
        <CropIcon className="w-6 h-6" cropName="Kukuřice" />
        <Trans>Kukuřice na zrno</Trans>
      </>
    ),
  },
];

const yieldPredictionParamsSchema = z.object({
  postalCode: z.string().min(1),
});

const START_YEAR = 2020;
const WINDOW_SIZE = 5;

type YearFilter = {
  label: string;
  value: number;
};

const getYearFilters = (now: DateTime = DateTime.now()): YearFilter[] => {
  const marchCutoff = DateTime.fromObject({
    year: now.year,
    month: 3,
    day: 31,
  });
  const showCurrentYear = now >= marchCutoff;
  const maxYear = showCurrentYear ? now.year : now.year - 1;
  const minYear = Math.max(START_YEAR, maxYear - WINDOW_SIZE + 1);

  const years: YearFilter[] = [];
  for (let year = maxYear; year >= minYear; year--) {
    years.push({ label: String(year), value: year });
  }

  return years;
};

const getDefaultYear = (now?: DateTime): number => {
  const filters = getYearFilters(now);
  return filters[0].value;
};

const path = "yield-predictions";

export {
  crops,
  getDefaultYear,
  getYearFilters,
  path,
  yieldPredictionParamsSchema,
};
export type { CropConfig, CropId, YearFilter };
